import Icon from "./IconBase";

const ChevronLeftIcon = (props) => (
  <Icon width="9" height="14" viewBox="0 0 9 14" fill="#A1AEB7" {...props}>
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 13L1 7L7 1"
        stroke="#0F0F0F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
);

export default ChevronLeftIcon;
